var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"main-button-icon",class:{ 'main-button-icon_hovered': _vm.type === 'icon' },attrs:{"disabled":_vm.disabled,"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }